import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../assets/Logo_Long1.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/Navbar.css';

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown when clicking Services
  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen(!dropdownOpen);
    setActiveSubmenu(null);
  };

  // Toggle submenus only when clicked, not on hover
  const toggleSubmenu = (e, submenu) => {
    e.preventDefault();
    setActiveSubmenu(activeSubmenu === submenu ? null : submenu);
  };

  // Close dropdown if user clicks outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
        setActiveSubmenu(null);
        setMenuOpen(false); // Close mobile menu on outside click
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg ${menuOpen ? 'expanded' : ''}`} ref={dropdownRef}>
      <div className='container'>
        {/* LOGO */}
        <NavLink className='navbar-brand' to='/'>
          <img src={Logo} alt='Westchester Music Lab' className='navbar-logo' />
        </NavLink>

        {/* BURGER MENU */}
        <button 
          className='navbar-toggler' 
          type='button' 
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span className='navbar-toggler-icon'></span>
        </button>

        {/* NAVBAR MENU */}
        <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`} id='navbarNav'>
          <ul className='navbar-nav ms-auto'>
            <li className='nav-item'><NavLink className='nav-link' to='/'>Home</NavLink></li>
            <li className='nav-item'><NavLink className='nav-link' to='/about'>About</NavLink></li>
            <li className='nav-item'><NavLink className='nav-link' to='/contact'>Contact</NavLink></li>
            
            {/* DROPDOWN MENU */}
            <li className={`nav-item dropdown ${dropdownOpen ? 'show' : ''}`}> 
            <a className='nav-link dropdown-toggle' href='#' onClick={toggleDropdown} style={{ position: 'relative' }}>
  Services
</a>

              <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
                {/* LESSONS */}
                {/* <li className={`dropdown-submenu ${activeSubmenu === 'lessons' ? 'show' : ''}`}> 
                  <a className='dropdown-item dropdown-toggle' href='#' onClick={(e) => toggleSubmenu(e, 'lessons')}>
                    Lessons & Education
                  </a>
                  <ul className={`dropdown-menu submenu ${activeSubmenu === 'lessons' ? 'show' : ''}`}>
                    <li><NavLink className='dropdown-item' to='/services/lessons/in-home'>In Home Lessons</NavLink></li>
                    <li><NavLink className='dropdown-item' to='/services/lessons/studio'>In Studio Lessons</NavLink></li>
                  </ul>
                </li> */}

                {/* STUDIO & PRODUCTION */}
                <li className={`dropdown-submenu ${activeSubmenu === 'studio' ? 'show' : ''}`}> 
                  <a className='dropdown-item dropdown-toggle' href='#' onClick={(e) => toggleSubmenu(e, 'studio')}>
                    Studio & Production
                  </a>
                  <ul className={`dropdown-menu submenu ${activeSubmenu === 'studio' ? 'show' : ''}`}>
                    <li><NavLink className='dropdown-item' to='/services/studio/recording'>Recording & Mastering</NavLink></li>
                    <li><NavLink className='dropdown-item' to='/services/studio/visual'>Photo & Video</NavLink></li>
                  </ul>
                </li>

                {/* LIVE SOUND & EVENTS */}
                <li className={`dropdown-submenu ${activeSubmenu === 'live-sound' ? 'show' : ''}`}> 
                  <a className='dropdown-item dropdown-toggle' href='#' onClick={(e) => toggleSubmenu(e, 'live-sound')}>
                    Live Sound & Events
                  </a>
                  <ul className={`dropdown-menu submenu ${activeSubmenu === 'live-sound' ? 'show' : ''}`}>
                    <li><NavLink className='dropdown-item' to='/services/live-sound/gear-rental'>Gear Rental</NavLink></li>
                    <li><NavLink className='dropdown-item' to='/services/live-sound/audio-engineer'>Audio Engineer</NavLink></li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;